import React from 'react';
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import CustomTab from './CustomTab';
import CustomTabList from './CustomTabList';
import CustomTabPanels from './CustomTabPanels';
import CustomTabPanel from './CustomTabPanel';
import { TabListProps, TabsProps } from '@chakra-ui/react';

type Props = {
  [x: string]: any,
  tabHeaders: React.ReactNode[],
  tabContents: React.ReactNode[],
  TabListStyle?: TabListProps,
} & Partial<TabsProps>;

export default function CustomTabs({
  tabHeaders,
  tabContents,
  TabListStyle,
  ...rest
}: Props) {
  const displayTabHeaders = () =>
    tabHeaders.map((header, i) => (
      <CustomTab key={i} minWidth={'fit-content'}>
        {header}
      </CustomTab>
    ));

  const displayTabContent = () =>
    tabContents.map((content, i) => (
      <CustomTabPanel key={i}>{content}</CustomTabPanel>
    ));

  return (
    <>
      <CC.Tabs {...rest} isLazy>
        <div style={{ overflow: 'auto' }}>
          <CustomTabList>{displayTabHeaders()}</CustomTabList>
        </div>

        <CustomTabPanels {...TabListStyle}>{displayTabContent()}</CustomTabPanels>
      </CC.Tabs>
    </>
  );
}
